module.exports = __webpack_public_path__ + "img/bg7.99e05569.png";